import { create } from '@bufbuild/protobuf'
import { useMutation, useQuery, useTransport, createConnectQueryKey } from '@connectrpc/connect-query'
import { useQueryClient } from '@tanstack/react-query'

import {
  calculateTransportationMileage,
  getTransportationItem,
  listItems,
  upsertTransportationItem,
} from '@/gen/cortado/v1/cortado-CortadoService_connectquery'
import { GetTransportationItemRequestSchema } from '@/gen/cortado/v1/cortado_pb'

export function useTransportationItem(organizationId: string) {
  const query = useQuery(
    getTransportationItem,
    create(GetTransportationItemRequestSchema, { organizationId }),
    { enabled: !!organizationId },
  )

  return {
    item: query.data?.item,
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error,
  }
}

export function useUpsertTransportationItem() {
  const queryClient = useQueryClient()
  const transport = useTransport()

  return useMutation(upsertTransportationItem, {
    onSuccess: (_response, request) => {
      queryClient.invalidateQueries({
        queryKey: createConnectQueryKey({
          schema: getTransportationItem,
          transport,
          input: { organizationId: request.organizationId },
          cardinality: 'finite',
        }),
      })
      queryClient.invalidateQueries({
        queryKey: createConnectQueryKey({
          schema: listItems,
          transport,
          cardinality: undefined,
        }),
      })
    },
  })
}

export function useCalculateTransportationMileage() {
  return useMutation(calculateTransportationMileage)
}
